import React, { Fragment , useContext , useEffect } from 'react'
import operatorContext from '../../../context/operator/operatorContext'
import {useAlert} from "react-alert";

const OperatorChangePassword = () => {
    const OperatorContext = useContext(operatorContext);

    const { updateOperatorPassword, operator, clearAlert } = OperatorContext; 

    const {  message } = operator

    const alert = useAlert()

    useEffect(() => {

        
        if (message.msg !== "") {
            alert.show(
                message.msg, message.msg_options
            )
            clearAlert()
        }

        //eslint-disable-next-line
    }, [OperatorContext]);

    const onSubmit = e => {

        e.preventDefault()

        let change_password_form = document.getElementById("change_password_form");

        let updated_operator_password = new FormData(change_password_form);
        updateOperatorPassword(updated_operator_password)
    }

    return (
        <Fragment>
             <div className="content-wrapper">
            <div className="container-fluid">
                <h3 className="make-bold">Password Settings</h3>
                <p>Update your password</p>
                {/* <!--Start Dashboard Content--> */}

                <div className="dashboard-inner-view">
                    <div className="row mt-3">
                        <div className="col-lg-8">

                            <ul className="profile-tab-view nav nav-pills mb-5" id="pills-tab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active ft-1-5" id="pills-personal-information-tab"
                                        data-toggle="pill" href="#pills-personal-information" role="tab"
                                        aria-controls="pills-personal-information" aria-selected="true">Change
                                        Password</a>
                                </li> 
                            </ul>
                            <div className="tab-content" id="pills-tabContent">

                                <div className="tab-pane fade show active" id="pills-personal-information" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <div className="profile-info-details">
                                        <div className="row">
                                            <div className="col-lg-7">
                                            <form onSubmit={onSubmit} id="change_password_form">
                                                    <div className="form-group mb-5">
                                                        <label>Current Password</label>
                                                        <div className="input-group mb-3">
                                                            <input type="password"
                                                                    name="current_password"
                                                                className="form-control form-control-custom-view border-right-0"
                                                                id="myInput" placeholder="Enter your current password"
                                                                aria-label="Enter your current password"
                                                                aria-describedby="basic-addon2" />
                                                            <div className="input-group-append">
                                                                <span className="input-group-text bg-white"
                                                                    id="basic-addon2"><svg
                                                                        xmlns="http://www.w3.org/2000/svg" width="24"
                                                                        height="24" viewBox="0 0 24 24" fill="none"
                                                                        stroke="currentColor" strokeWidth="2"
                                                                        strokeLinecap="round" strokeLinejoin="round"
                                                                        className="feather feather-eye-off cursor-pointer small-icon"
                                                                        id="toggleVisibility">
                                                                        <path
                                                                            d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                                                                        </path>
                                                                        <line x1="1" y1="1" x2="23" y2="23"></line>
                                                                    </svg></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>New Password</label>
                                                        <input type="password"
                                                            name="new_password"
                                                            className="form-control form-control-custom-view"
                                                            placeholder="Enter your new password" />
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Confirm New Password</label>
                                                        <input type="password"
                                                            name="confirm_password"
                                                            className="form-control form-control-custom-view"
                                                            placeholder="Confirm your new password" />
                                                    </div>
                                                    <div className="form-group">
                                                        <button type="submit"
                                                            className="btn btn-orange btn-custom-view btn-block text-white d-flex justify-content-center align-items-center">Change
                                                            password</button>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="col-lg-3">
                                                <a href="!#">
                                                    <div className="position-relative">
                                                        <div className="avatar-holder-profile bord-radius-50 mx-auto">
                                                            <img src="assets/images/avatar-big.png"
                                                                className="img-fluid object-fit-cover object-pos-center h-100 w-100" alt="" />
                                                        </div>
                                                        <img src="assets/images/vector-avatar.png"
                                                            className="img-fluid vector-avatar-overlay" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!--End Dashboard Content--> */}

            </div>
            {/* <!-- End container-fluid--> */}

        </div>
        {/* End wrapper */}
        </Fragment>
    )
}

export default OperatorChangePassword
